import { render, staticRenderFns, recyclableRender, components } from "./demand-hall.vue?vue&type=template&id=0d147204&scoped=true&"
var renderjs
import script from "./demand-hall.vue?vue&type=script&lang=js&"
export * from "./demand-hall.vue?vue&type=script&lang=js&"
import style0 from "./demand-hall.vue?vue&type=style&index=0&lang=css&"
import style1 from "./demand-hall.vue?vue&type=style&index=1&id=0d147204&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d147204",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/demand-hall/demand-hall.vue"
export default component.exports